<div class="mt-1">

    <div *ngIf="coments.length > 0" [ngClass]="modalV == true ?'refreshParentV':'refreshParent'">
        <div class="col-auto">
            <div id="tooltips-container">
                <a (click)="loadData()" class="text-reset font-17  px-2 d-inline-block pointer ">
                    <i class="fe-refresh-ccw refresh" placement="top" [ngbTooltip]="'BOARD.REFRESH' | translate"></i>
                </a>
            </div>
        </div>
    </div>

    <div class="chat position-relative">
        <app-ui-preloader id="spinner" [display]="loading"></app-ui-preloader>

        <ngx-simplebar *ngIf="coments.length > 0 || modalV == false"
            [ngClass]="modalV == true ?'contentHightV':'contentHight'" #scrollMe>
            <!-- messages start -->
            <ul class="conversation-list p-0 mb-0">
                <li class="clearfix" *ngFor="let message of coments">
                    <div class="chat-avatar" style="height: 28px; width: 28px;">
                        <img [src]="message.photo" class="rounded-circle img-thumbnail"
                            [alt]="message.author?.firstName" />
                        <p title="{{message.createdAt | date:' hh:mma yyyy-MM-dd'}}" class="text-muted messageTime">
                            {{message.createdAt | date:"HH:mm"}}</p>
                    </div>
                    <div class="conversation-text">
                        <!-- <ng-container *ngFor="let item of message.message"> -->
                        <div class="ctext-wrap mb-1" id="messageBox">
                            <p class="text-dark textHeader mb-0 m-0">{{message.author?.firstName}}</p>
                            <p class="text-dark message mb-0 m-0 ms-1">
                                {{message.message}}
                            </p>
                        </div>
                        <div *ngIf="message.uploadedFiles" class="ms-1">
                            <ng-container *ngFor="let item of message.uploadedFiles">
                                <div class="card  shadow-none border text-start">
                                    <div>
                                        <div class="row align-items-center">
                                            <div class="col-auto">
                                                <img *ngIf="item.mimetype.includes('image')"
                                                    [ngClass]="modalV == true ?'avatarPs':'avatar-sm'"
                                                    class="rounded bg-light" [alt]="item.originalname" [src]="item.url">
                                                <div *ngIf="!item.mimetype.includes('image')" class="icon-file rounded">
                                                    <i [class]="item.fileIcon"></i>
                                                </div>
                                            </div>
                                            <div class="col ps-0">
                                                <a class="text-primary fw-bold">{{item.originalname}}</a>
                                                <p class="text-muted mb-0">{{item.fileSize}}</p>
                                            </div>
                                            <div class="col-auto">
                                                <!-- Button -->
                                                <a (click)="preview(item)" class="btn btn-link text-muted"
                                                    [ngClass]="modalV == true ?'btnPs':''">
                                                    <i class="mdi mdi-magnify"
                                                        [ngClass]="modalV == true ?'btnPs':''"></i>
                                                </a>
                                                <a href="{{item.url}}" class="btn btn-link text-muted "
                                                    [ngClass]="modalV == true ?'btnPs':''">
                                                    <i class="dripicons-download me-1"
                                                        [ngClass]="modalV == true ?'btnPs':''"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-container>
                            <!-- download="proposed_file_name" -->
                        </div>
                        <!-- </ng-container> -->
                    </div>
                    <ng-container *ngTemplateOutlet="ChatMessageDropdown;context:{message:message}"></ng-container>
                </li>
                <div *ngIf="moreThan40" class=" d-flex justify-content-center commentBadgeParent">
                    <span (click)="pageSize=500; loadData()" class="badge badge-soft-warning me-1 commentBadge pointer">
                        {{'BOARD.LOADMORE' | translate}}
                    </span>
                </div>
            </ul>
            <!-- messages end -->
        </ngx-simplebar>

        <!-- new message form -->
        <form [formGroup]="chatForm" class="form mt-0">
            <div class="chat-input">
                <input type="text" class="form-control commentInput" appendTo="body" [mention]="mentions"
                    [mentionConfig]="{labelKey:'name',mentionSelect:mentionSelect, dropUp:true}"
                    [placeholder]="'BOARD.COMMENT.PLACEHOLDER' | translate" formControlName="message" required
                    [ngClass]="{ 'is-invalid': showError}" />

                <div class="form-validation" *ngIf="showError">
                    {{ 'BOARD.COMMENT.ERRORCOMMENT' | translate }}
                </div>

            </div>
            <div class="btn-group ms-1">
                <div (click)="showModalFiles()" [attr.disabled]="loading"
                    class="commentSaveButton d-flex justify-content-center">
                    <i class="mdi mdi-paperclip"></i>
                    <p *ngIf="formChat.files.value.length > 0" class="text-danger numberFiles">
                        {{formChat.files.value.length}}</p>

                </div>

                <i [attr.disabled]="loading" (click)="addComent()" class="mdi mdi-send send"></i>
                <!-- <button type="submit"
                    class="btn btn-success chat-send w-100 commentSaveButton d-flex justify-content-center"
                    [disabled]="loading">
                </button> -->
            </div> <!-- end col -->
        </form>
        <!-- end row -->
    </div>
</div>

<!-- reusable templates -->
<ng-template #ChatMessageDropdown let-message="message">
    <div class="conversation-actions" ngbDropdown>
        <button ngbDropdownToggle class="btn btn-sm btn-link" id="chatMessageDropdown" aria-expanded="false">
        </button>
        <div ngbDropdownMenu class="dropdown-menu-end" aria-labelledby="chatMessageDropdown">
            <a class="pointer text-dark" ngbDropdownItem
                (click)="deleteComent(message)">{{'BOARD.DELETECOMMENTS'|translate}}</a>
        </div>
    </div>
</ng-template>


<app-modal-files #modal [onlyPreview]="false" (saveModal)="saveNeedFiles($event)"
    (closeModal)="this.showModal = false; showModalRequestFiles ? showModalRequestFiles = false : null;">
</app-modal-files>